module.exports = __webpack_public_path__ + "img/EChariotArchers64_ua.3eeeb071.webp";